<template>
  <div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.show"
      width="800px"
      center
    >
      <el-form
        v-loading="loading"
        :model="editForm"
        label-width="165px"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item :label="$t('Operator')" v-show="zong" prop="SellerId">
          <el-select
            v-model="editForm.SellerId"
            :disabled="dialogData.title == $t('Edit')"
            :placeholder="$t('Operator')"
            @change="changeSellerId"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in userSellerList"
              :key="index"
              :label="item.SellerName"
              :value="item.SellerId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Channel')" prop="ChannelId">
          <el-select
            v-model="editForm.ChannelId"
            :disabled="dialogData.title == $t('Edit')"
            :placeholder="$t('channel')"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in dialogchannel"
              :key="item.ChannelId"
              :label="item.Name"
              :value="item.ChannelId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('botUsername')" prop="TgRobotUserName">
          <el-input
            v-model="editForm.TgRobotUserName"
            :placeholder="$t('botUsername')"
            clearable
            :disabled="isEditorInfo"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('BotToken')" prop="TgRobotToken">
          <el-input
            v-model="editForm.TgRobotToken"
            :placeholder="$t('BotToken')"
            clearable
            :disabled="isEditorInfo"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('CustomerAccount')" prop="KefuAccount">
          <el-select
            v-model="editForm.KefuAccount"
            @change="changeKefuAccount"
            :placeholder="$t('CustomerAccount')"
            style="width: 100%"
            clearable
            :disabled="isEditorInfo"
          >
            <el-option
              v-for="(item, index) in accountList"
              :key="index"
              :label="item.KefuAccount"
              :value="item.KefuAccount"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CustomerServiceTGAccount')" prop="KefuTgUserName">
          <el-select
            v-model="editForm.KefuTgUserName"
            @change="changeTgUserName"
            :placeholder="$t('CustomerServiceTGAccount')"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="(item, index) in PhoneList"
              :key="index"
              :label="OnChangeBtnUrl(item.TgUsername)"
              :value="OnChangeBtnUrl(item.TgUsername)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('GameLink')" prop="GameUrl">
          <el-select
            v-model="editForm.GameUrl"
            :placeholder="$t('GameLink')"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in gameLinkList"
              :key="index"
              :label="item.Host"
              :value="item.Host"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ReportGroupChatId')" prop="GroupChatId">
          <el-input
            v-model="editForm.GroupChatId"
            :placeholder="$t('ReportGroupChatId')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('LibraryWelcomeCopy')">
          <el-button type="primary" @click="eidtText(1)">{{$t('EditCopy')}}</el-button>
        </el-form-item>
        <el-form-item :label="$t('NotInLibraryWelcomeCopy')">
          <el-button type="primary" @click="eidtText(6)">{{$t('EditCopy')}}</el-button>
        </el-form-item>
        <el-form-item :label="$t('H5ActivityPopupCopy')">
          <el-button type="primary" @click="OnClickH5First">{{$t('EditCopy')}}</el-button>
        </el-form-item>
        <el-form-item :label="$t('AutoIssuanceSecondBonus')" prop="IsAotoTyj2">
          <el-select
            v-model="editForm.IsAotoTyj2"
            :placeholder="$t('IssueBonus')"
            style="width: 100%"
            clearable
          >
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Status')" prop="IsEnable">
          <el-select
            v-model="editForm.IsEnable"
             :placeholder="$t('Status')"
            style="width: 100%"
            clearable
          >
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SameIP')" prop="IsIPRestriction">
          <el-tooltip effect="dark" placement="top" style="margin-left: -6px">
            <div slot="content">{{$t('IpRestrictionWarning')}}</div>
            <div style="display: inline-block">
              <span class="el-icon-question"></span>
            </div>
          </el-tooltip>
          <el-select
            v-model="editForm.IsIPRestriction"
           :placeholder="$t('SameIPLimit')"
            style="width: 50%; margin-left: 6px"
            clearable
          >
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('IPWhitelist')" v-if="editForm.IsIPRestriction == 1">
          <el-tooltip effect="dark" placement="top" style="margin-left: -6px">
            <div slot="content">{{$t('WhitelistUsersNoIPLimit')}}</div>
            <div style="display: inline-block">
              <span class="el-icon-question"></span>
            </div>
          </el-tooltip>
          <el-table
            class="levelSet"
            :data="configTableData"
            style="width: 100%"
            border
            :cell-style="{ padding: '0px' }"
          >
            <el-table-column prop="WhiteIP" :label="$t('IPWhitelist')"></el-table-column>
            <el-table-column  :label="$t('Actions')">
              <template slot-scope="scope">
                <el-button type="text" @click="editRow(scope.row, scope.$index)"
                  >{{$t('Edit')}}</el-button
                >
                <el-button
                  style="color: red"
                  type="text"
                  @click="delRow(scope.$index)"
                  >{{$t('Delete')}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" icon="el-icon-plus" @click="addRow"
            >{{$t('AddWhitelistIPConfig')}}</el-button
          >
        </el-form-item>
        <el-form-item :label="$t('SameDeviceCodeLimitSwitch')" prop="IsDeviceRestriction">
          <el-tooltip effect="dark" placement="top" style="margin-left: -6px">
            <div slot="content">{{$t('AfterLimitEnableSameDeviceCodePlayersCannotReceiveTrialBonus')}}</div>
            <div style="display: inline-block">
              <span class="el-icon-question"></span>
            </div>
          </el-tooltip>
          <el-select
            v-model="editForm.IsDeviceRestriction"
            :placeholder="$t('EnableOption')"
            style="width: 50%; margin-left: 6px"
            clearable
          >
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('LinkedSwitch')" prop="IsWalletRestriction">
          <el-tooltip effect="dark" placement="top" style="margin-left: -6px">
            <div slot="content">{{$t('AddressRestrictionWarning')}}</div>
            <div style="display: inline-block">
              <span class="el-icon-question"></span>
            </div>
          </el-tooltip>
          <el-select
            v-model="editForm.IsWalletRestriction"
            :placeholder="$t('EnableOption')"
            style="width: 50%; margin-left: 6px"
            clearable
          >
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')" prop="GoogleCode">
          <el-input
            v-model="editForm.GoogleCode"
           :placeholder="$t('GoogleVerificationCode')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="submitForm('editForm')"
          >{{$t('Confirm')}}</el-button
        >
        <el-button size="medium" @click="dialogData.show = false"
          >{{$t('Cancel')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑文案 -->
    <el-dialog
      :title="$t('EditCopy')"
      :visible.sync="showEditText"
      width="800px"
      center
    >
      <el-form
        :model="textForm"
        label-width="130px"
        :rules="textRules"
        ref="textForm"
      >
        <el-form-item :label="$t('language')" prop="Lang">
          <el-radio-group v-model="mRadio" @change="OnHandleRadioChange">
            <div
              v-for="item in mLangOptions"
              :key="item"
              style="position: relative; display: inline-block; margin: 4px"
            >
              <el-radio-button :label="item" :disabled="loading">
                {{ langmap[item] }}<span v-if="item == mEnLangId">({{$t('RequiredField')}})</span>
              </el-radio-button>
              <el-badge
                v-if="OnIsShowRedDot(item)"
                is-dot
                class="red-dot"
              ></el-badge>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('CopyType')" prop="type">
          <el-select
            v-model="textForm.type"
            :placeholder="$t('SelectCopyType')"
            @change="this.textForm.url = ''"
            style="width: 100%"
            clearable
          >
            <el-option :label="$t('Copy')" :value="1"></el-option>
            <el-option :label="$t('Image1')+'+'+$t('Copy')" :value="2"></el-option>
            <el-option :label="$t('Video')+'+'+$t('Copy')" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="label" prop="url" v-if="textForm.type != 1">
          <el-upload
            class="avatar-uploader"
            :action="this.$global.baseURL + '/upload'"
            :show-file-list="false"
            :on-success="handleSuccess"
            :headers="{ 'x-token': token }"
          >
            <img
              v-if="textForm.url && fileType == 1"
              :src="textForm.url"
              class="avatar"
            />
            <video
              autoplay
              controls
              v-else-if="textForm.url && fileType == 2"
              :src="textForm.url"
              class="videole"
            ></video>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('Copy')" prop="text">
          <el-checkbox v-model="textForm.is_markdown"
            >{{$t('EnableMarkdownSyntax')}}</el-checkbox
          >
          <el-input
            type="textarea"
            :rows="5"
            v-model="textForm.text"
            :placeholder="$t('EnterCopy')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('ButtonConfig')"
          v-if="showEditType == 1 || showEditType == 6"
        >
          <el-tooltip effect="dark" placement="top" style="margin-left: -6px">
            <div slot="content">{{$t('MaxButtonsPerRow')}}</div>
            <div style="display: inline-block">
              <span class="el-icon-question"></span>
            </div> </el-tooltip
          ><span style="color: red">{{$t('DragToAdjustOrder')}}</span>
          <el-table
            class="levelSet"
            row-key="id"
            id="sortTable"
            :data="textForm.Rows"
            style="width: 100%"
            border
            :cell-style="{ padding: '0px' }"
          >
            <el-table-column label="" width="48px" align="center">
              <template> ⇅ </template>
            </el-table-column>

            <el-table-column :label="$t('Button')" width="470px" align="center">
              <template slot-scope="scope">
                <div
                  style="display: flex;justify-content:space-between;width: 100%"
                >
                  <div
                    v-for="(item, index) in scope.row.text"
                    :key="index"
                    style="flex: 1; margin-right: 5px"
                  >
                    <el-button
                      type="info"
                      style="width: 100%; cursor: default"
                      class="no-hover"
                      >{{ item }}</el-button
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('Actions')">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editButtonRow(scope.row, scope.$index)"
                  >{{$t('Edit')}}</el-button
                >
                <el-button
                  style="color: red"
                  type="text"
                  @click="delButtonRow(scope.$index)"
                  >{{$t('Delete')}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" icon="el-icon-plus" @click="addBtnRow"
            >{{ $t('AddButtonConfig') }}</el-button
          >
        </el-form-item>
        <div v-for="(item, index) in textForm.buttons" :key="index" v-else>
          <div v-for="(itemJ, indexJ) in item" :key="indexJ">
            <el-form-item :label="$t('ButtonType')" prop="type">
              <el-select
                v-model="itemJ.type"
                :placeholder="$t('SelectButtonType')"
                style="width: 100%"
                clearable
              >
                <el-option :label="$t('link')" :value="1"></el-option>
                <el-option :label="$t('MiniProgram')" :value="2"></el-option>
                <!-- <el-option label="分享" :value="3"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="链接地址" v-if="itemJ.type == 1">
              <el-input
                type="string"
                v-model="itemJ.url"
                :placeholder="$t('PleaseEnter')"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('ButtonText')">
              <el-input
                type="string"
                v-model="itemJ.text"
                :placeholder="$t('PleaseEnter')"
                style="width: 100%"
              ></el-input>
              <span
                style="margin-left: 10px; color: red"
                v-if="itemJ.text == ''"
                >{{ $t('ButtonTextRequired') }}</span
              >
            </el-form-item>
          </div>
        </div>
        <el-form-item label="" v-if="mCanSyncEn && mRadio == mEnLangId">
          <div class="red-box">
            <el-button type="primary" @click="OnClickEnSync"
              >{{$t('SyncConfigToAllLanguages')}}</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="medium"
          type="primary"
          @click="submitTextForm('textForm')"
          >{{$t('Confirm')}}</el-button
        >
        <el-button size="medium" @click="showEditText = false">{{$t('Cancel')}}</el-button>
      </span>
    </el-dialog>
    <!-- 白名单IP配置弹窗 -->
    <el-dialog
      :title="$t('EditWhitelistIP')"
      :visible.sync="showLevel"
      width="400px"
      center
      @closed="showLevel = false"
    >
      <el-form ref="levelForm" :model="levelForm" label-width="150px">
        <el-form-item :label="$t('NewWhitelistIP')">
          <el-input
            type="string"
            v-model="levelForm.WhiteIP"
            :placeholder="$t('PleaseEnter')"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLevel = false">{{$t('Cancel')}}</el-button>
        <el-button type="primary" @click="submitLevel">{{ $t('Confirm2') }}</el-button>
      </span>
    </el-dialog>
    <!--按钮配置弹窗 -->
    <el-dialog
      :title="$t('ButtonConfig')"
      :visible.sync="showButtonEdit"
      width="900px"
      center
      @closed="showButtonEdit = false"
    >
      <div class="root">
        <div
          v-for="(item, index) in textForm_CurentRow.buttons"
          :key="index"
          class="gameItem"
          v-show="textForm_CurentRow.buttons.length"
        >
          <div class="lab">{{$t('ButtonType')}}</div>
          <el-select
            v-model="item.type"
            :placeholder="$t('SelectButtonType')"
            style="width: 90px"
          >
            <el-option :label="$t('link')" :value="1"></el-option>
            <el-option :label="$t('MiniProgram')" :value="2"></el-option>
          </el-select>
          <div class="lab">{{$t('ButtonText')}}</div>
          <el-input
            type="string"
            v-model="item.text"
            :placeholder="$t('EnterButtonText')"
            style="width: 150px"
          ></el-input>
          <div class="lab" v-if="item.type == 1">{{$t('LinkAddress')}}</div>
          <el-input
            type="string"
            v-model="item.url"
            :placeholder="$t('EnterLinkAddress')"
            style="width: 350px"
            v-if="item.type == 1"
          ></el-input>
          <el-button
            style="color: red"
            type="text"
            icon="el-icon-delete"
            @click="handleDelItem(index)"
            >{{$t('Delete')}}</el-button
          >
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="handleAddItem"
          style="width: 150px"
          >{{$t('newAnnouncementAreation')}}</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showButtonEdit = false">{{$t('Cancel')}}</el-button>
        <el-button type="primary" @click="submitButton">{{$t('Confirm2')}}</el-button>
      </span>
    </el-dialog>
    <EnH5U50Dialog v-if="mH5U50Data.show" :dialogData="mH5U50Data" />
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { app } from "@/api/app.js";
import base from "@/api/base.js";
import EnH5U50Dialog from "./EnH5U50Dialog.vue";
export default {
  extends: base,
  components: { EnH5U50Dialog },
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mTgRobotType: this.$global.ETgRobotType.E_EnRobot,
      editForm: {
        ChannelId: "",
        TgRobotUserName: "",
        KefuTgUserName: "",
        TgRobotToken: "",
        GameUrl: "",
        Welcome: "",
        Welcome2: "", // 不在库欢迎文案
        BindMsg: "",
        GuideMsg: "",
        FirstChargeActive: "",
        IsEnable: "",
        IsTiyanjin: 1, // 固定有
        IsAotoTyj2: 2, // 默认关闭
        IsIPRestriction: 1, // 默认开启
        IsDeviceRestriction: 1, // 默认开启
        IsWalletRestriction: 1, // 默认开启
        GoogleCode: "",
        FuLiMsg: "",
        SellerId: "",
        GroupChatId: 0,
        KefuAccount: "",
        TgAccountId: "",
        IPWhitelist: "",
        H5KefuPopText: "",
        H5KefuLink: "",
      },
      rules: {
        SellerId: [
          { required: true, message: this.$t('SelectOperatorAgain'), trigger: "change" },
        ],
        ChannelId: [
          { required: true, message: this.$t('SelectChannel'), trigger: "change" },
        ],
        TgRobotUserName: [
          { required: true, message: this.$t('EnterBotName'), trigger: "blur" },
        ],
        GroupChatId: [
          { required: true, message: this.$t('EnterReportGroupChatId'), trigger: "blur" },
        ],
        TgRobotToken: [
          {
            required: true,
            message: this.$t('EnterBotToken'),
            trigger: "blur",
          },
        ],
        KefuAccount: [
          {
            required: true,
            message: this.$t('SelectCustomerServiceAccount'),
            trigger: "change",
          },
        ],
        Phone: [
          {
            required: true,
            message:this.$t('SelectCustomerServiceTGPhoneNumber'),
            trigger: "change",
          },
        ],
        KefuTgUserName: [
          {
            required: true,
            message: this.$t('SelectBotCustomerServiceTGNumber'),
            trigger: "change",
          },
        ],
        GameUrl: [
          { required: true, message: this.$t('EnterGameLink'), trigger: "change" },
        ],
        GoogleCode: [
          { required: true, message: this.$t('EnterGoogleVerificationCode'), trigger: "blur" },
        ],
        IsEnable: [
          { required: true, message: this.$t('StatusQuery'), trigger: "change" },
        ],
        IsIPRestriction: [
          { required: true, message: "请选择是否同IP限制", trigger: "change" },
        ],
        IsDeviceRestriction: [
          {
            required: true,
            message: this.$t('SelectDeviceLimit'),
            trigger: "change",
          },
        ],
        IsWalletRestriction: [
          {
            required: true,
            message: this.$t('SelectAddressLimit'),
            trigger: "change",
          },
        ],
        // IsTiyanjin: [
        //   {
        //     required: true,
        //     message: this.$t('SelectBonusIssuance'),
        //     trigger: "change",
        //   },
        // ],
        IsAotoTyj2: [
          {
            required: true,
            message: this.$t('PleaseSelect')+this.$t('AutoIssuanceSecondBonus'),
            trigger: "change",
          },
        ],
      },
      textRules: {
        type: [
          { required: true, message: this.$t('SelectCopyType'), trigger: "change" },
        ],
        url: [{ required: true, message: this.$t('EnterLink'), trigger: "blur" }],
        text: [{ required: true, message: this.$t('EnterCopy'), trigger: "blur" }],
      },
      loading: false,
      showEditText: false,
      showEditType: "",
      textForm: {
        type: "",
        url: "",
        text: "",
        buttons: [],
        Rows: [],
      },
      token: sessionStorage.getItem("token"),
      baseurl: JSON.parse(sessionStorage.getItem("userdata")).FileBaseUrl,
      gameLinkList: [],
      accountList: [],
      showLevel: false,
      showButtonEdit: false,
      levelForm: {
        WhiteIP: "",
      },
      textForm_CurentRow: {},
      LevelType: "",
      ButtonType: "",
      LevelRowIndex: "",
      ButtonRowIndex: "",
      configTableData: [],
      mH5U50Data: {
        title: this.$t('EditCopy'),
        show: false,
        row: {},
      },
      mRadio: 2,
      mEnLangId: 2,
      mLangOptions: [],
      mLangs: {},
      mCanSyncEn: false,
    };
  },
  computed: {
    isEditorInfo() {
      // 编辑模式下，禁止修改：机器人Token，请输入机器人名称，客服后台账号
      return this.dialogData.title == this.$t('Edit');
    },
    placeholder() {
      if (this.textForm.type == 1 || !this.textForm.type) {
        return "请输入图片或视频链接";
      }
      if (this.textForm.type == 2) {
        return "请输入图片链接";
      }
      if (this.textForm.type == 3) {
        return "请输入视频链接";
      }
    },
    label() {
      if (this.textForm.type == 1 || !this.textForm.type) {
        return this.$t('imageOrVideo')
      }
      if (this.textForm.type == 2) {
        return "图片";
      }
      if (this.textForm.type == 3) {
        return "视频";
      }
    },
    dialogchannel() {
      let channelList = JSON.parse(localStorage.getItem("channel")) || [];
      let arr = [];
      if (this.editForm.SellerId) {
        arr = channelList.filter(
          (item) => item.SellerId == this.editForm.SellerId
        );
      } else {
        arr = channelList;
      }
      return arr;
    },
    fileType() {
      if (this.textForm.type == 1 || !this.textForm.type) {
        return 1;
      }
      if (this.textForm.type == 2) {
        return 1;
      }
      if (this.textForm.type == 3) {
        return 2;
      }
    },
    PhoneList() {
      if (this.editForm.KefuAccount) {
        let arr = [];
        this.accountList.forEach((item) => {
          if (item.KefuAccount == this.editForm.KefuAccount) {
            arr = item.TgAccount;
          }
        });
        return arr;
      }
    },
  },
  created() {
    this.mLangOptions = [];
    this.mLangOptions.push(this.mEnLangId);
    this.langs.forEach((elem) => {
      if (elem.id != this.mEnLangId) {
        this.mLangOptions.push(elem.id);
      }
    });

    this.app = app;
    this.getChannel(this.filters.SellerId);
    if (this.dialogData.title == this.$t('Edit')) {
      this.getDetail();
    } else {
      if (!this.zong) this.editForm.SellerId = this.filters.SellerId;
    }
  },
  methods: {
    OnClickEnSync() {
      this.mCanSyncEn = false;
      let tLangs = this.OnGetLangs();
      this.mLangOptions.forEach((elem) => {
        tLangs[elem] = app.clone(tLangs[this.mEnLangId]);
      });
    },
    OnGetLangs() {
      return this.mLangs;
    },
    OnIsShowRedDot(pLang) {
      let tLangs = this.OnGetLangs();
      if (tLangs[pLang] && tLangs[pLang].text) return true;
      return false;
    },
    OnHandleRadioChange(pValue) {
      let tLangs = this.OnGetLangs();
      if (!tLangs[pValue]) {
        tLangs[pValue] = {
          type: this.textForm.type,
          url: this.textForm.url,
          text: this.textForm.text,
          buttons: this.textForm.buttons,
          is_markdown: this.textForm.is_markdown,
          Rows: this.textForm.Rows,
        };
      }
      this.textForm = tLangs[pValue];
    },
    OnClickH5First() {
      this.mH5U50Data.row = this.editForm;
      this.mH5U50Data.show = true;
    },
    initSort() {
      const el = document.querySelector(
        "#sortTable .el-table__body-wrapper > table > tbody"
      );
      new Sortable(el, {
        onEnd: (evt) => {
          const currRow = this.textForm.Rows.splice(evt.oldIndex, 1)[0];
          this.textForm.Rows.splice(evt.newIndex, 0, currRow);
        },
      });
    },
    //删除一个按钮
    handleDelItem(index) {
      this.textForm_CurentRow.buttons.splice(index, 1);
    },
    //增加一个按钮
    handleAddItem() {
      if (
        this.textForm_CurentRow.buttons &&
        this.textForm_CurentRow.buttons.length >= 3
      ) {
        this.$message.warning("每行不能超过3个按钮");
        return;
      }
      this.textForm_CurentRow.buttons.push({
        type: 1,
        text: "",
        url: "",
      });
    },
    // 编辑按钮配置
    editButtonRow(row, index) {
      this.showButtonEdit = true;
      this.ButtonType = 2;
      this.ButtonRowIndex = index;
      this.textForm_CurentRow = JSON.parse(
        JSON.stringify(this.textForm.Rows[index])
      );
    },
    // 删除按钮配置
    delButtonRow(index) {
      this.textForm.Rows.splice(index, 1);
    },
    // 新增按钮配置
    addBtnRow() {
      this.showButtonEdit = true;
      this.ButtonType = 1;
      this.ButtonRowIndex = "";
      this.textForm_CurentRow = {
        id: this.textForm.Rows.length + 1,
        text: "",
        buttons: [
          {
            type: 1,
            text: "",
            url: "",
          },
        ],
      };
    },
    // 确认新增按钮编辑
    submitButton() {
      if (
        this.textForm_CurentRow &&
        this.textForm_CurentRow.buttons &&
        this.textForm_CurentRow.buttons.length > 0
      ) {
        if (!this.checkButtonValid()) {
          return;
        }
        this.textForm_CurentRow.text = this.textForm_CurentRow.buttons.map(
          (item) => item.text
        );
        let iDate = JSON.parse(JSON.stringify(this.textForm_CurentRow));
        // console.warn("iDate", iDate);
        if (this.ButtonType == 1) {
          if (!this.textForm.Rows) {
            this.textForm.Rows = [];
          }
          this.textForm.Rows.push(iDate);
        } else {
          this.textForm.Rows.splice(this.ButtonRowIndex, 1, iDate);
        }
      }
      this.showButtonEdit = false;
    },
    checkButtonValid() {
      let isValid = true;
      for (let i = 0; i < this.textForm_CurentRow.buttons.length; i++) {
        let item = this.textForm_CurentRow.buttons[i];
        if (!item.text) {
          isValid = false;
          this.$message.warning(this.$t('ButtonTextRequired'));
          break;
        }
        if (item.type == 1) {
          if (!item.url) {
            isValid = false;
            this.$message.warning("链接类型的链接地址不能为空");
            break;
          } else if (!/^(http|https):\/\/(\S+)$/.test(item.url)) {
            isValid = false;
            this.$message.warning(
              "链接类型的链接地址需要是http://或https://开头"
            );
            break;
          }
        }
      }
      return isValid;
    },
    // 编辑配置
    editRow(row, index) {
      this.showLevel = true;
      this.LevelType = 2;
      this.LevelRowIndex = index;
      this.levelForm.WhiteIP = row.WhiteIP;
    },
    // 删除配置
    delRow(index) {
      this.configTableData.splice(index, 1);
    },
    // 新增配置
    addRow() {
      this.showLevel = true;
      this.LevelType = 1;
      this.LevelRowIndex = "";
      this.levelForm.WhiteIP = "";
    },
    // 确认新增编辑
    submitLevel() {
      this.showLevel = false;
      if (this.levelForm.WhiteIP == "") return;
      if (this.LevelType == 1) {
        this.configTableData.push({
          WhiteIP: String(this.levelForm.WhiteIP),
        });
      } else {
        let data = {
          WhiteIP: String(this.levelForm.WhiteIP),
        };
        this.configTableData.splice(this.LevelRowIndex, 1, data);
      }
    },
    // 需要参与完成的局数 处理
    handlePlayCountInput(value) {
      // 只允许输入整数
      const regex = /^\d*$/;
      if (regex.test(value)) {
        this.editForm.PlayCount = value;
      } else {
        // 如果输入的值不符合整数格式，则去掉最后一个字符
        this.editForm.PlayCount = value.slice(0, -1);
      }
    },
    // 选择运营商
    changeSellerId() {
      this.editForm.ChannelId = "";
      this.editForm.KefuAccount = "";
      this.editForm.KefuTgUserName = "";
      this.editForm.GameUrl = "";
      this.getAccount();
    },
    // 选择客服后台账号
    changeKefuAccount(val) {
      if (val) {
        let GroupName = this.accountList.find(
          (item) => item.KefuAccount == val
        ).CSGroup;
        this.getGameLink(GroupName);
      }
    },
    // 选择客服TG号
    changeTgUserName(val) {
      this.PhoneList.forEach((item) => {
        if (this.OnChangeBtnUrl(item.TgUsername) == val) {
          this.editForm.TgAccountId = item.Id;
        }
      });
      this.editForm.GameUrl = "";
    },
    // 获取游戏链接
    getGameLink(val) {
      if (!val || val == "") {
        console.warn("Warn:===== EnAddData getGameLink val is null");
        return;
      }
      const data = {
        SellerId: +this.editForm.SellerId,
        GroupName: val,
        ChannelId: 0,
        TgRobotType: this.mTgRobotType,
      };
      app.post(
        "/kefu/host_list",
        data,
        (res) => {
          if (res.code == 200) {
            let arr = res.data || [];
            this.gameLinkList = arr.map((item) => {
              return {
                Host: `https://${item.Host}`,
              };
            });
          }
        },
        true
      );
    },
    // 获取TG后台账号列表
    getAccount() {
      const data = {
        SellerId: +this.editForm.SellerId,
        ChannelId: 0,
        TgRobotType: this.mTgRobotType,
      };
      app.post(
        "/tgAccount/kefu_list ",
        data,
        (res) => {
          if (res.code == 200) {
            this.accountList = res.data.list || [];
          }
        },
        true
      );
    },

    handleSuccess(res, file) {
      this.textForm.url = this.baseurl + res.data.filename;
      this.$forceUpdate();
    },
    onGetWelComeBtns() {
      return [[{ type: 2, url: "", text: this.$t('startGame') }]];
    },
    onGetWelCome2Btns() {
      return [
        [
          { type: 2, url: "", text: this.$t('startGame') },
          { type: 1, url: "https://t.me/TRXHBbot", text: "返回" },
        ],
      ];
    },
    // 编辑文案
    eidtText(type) {
      this.showEditType = type;
      this.showEditText = true;

      let Welcome = this.editForm.Welcome
        ? JSON.parse(this.editForm.Welcome)
        : {};
      if (!Welcome.buttons || Welcome.buttons.length < 1) {
        Welcome.buttons = this.onGetWelComeBtns();
      }

      let Welcome2 = this.editForm.Welcome2
        ? JSON.parse(this.editForm.Welcome2)
        : {};
      if (!Welcome2.buttons || Welcome2.buttons.length < 1) {
        Welcome2.buttons = this.onGetWelCome2Btns();
      }
      let BindMsg = this.editForm.BindMsg
        ? JSON.parse(this.editForm.BindMsg)
        : {};
      let GuideMsg = this.editForm.GuideMsg
        ? JSON.parse(this.editForm.GuideMsg)
        : {};
      let FirstChargeActive = this.editForm.FirstChargeActive
        ? JSON.parse(this.editForm.FirstChargeActive)
        : {};
      let FuLiMsg = this.editForm.FuLiMsg
        ? JSON.parse(this.editForm.FuLiMsg)
        : {};
      if (type == 1) {
        this.textForm = { ...Welcome };
      }
      if (type == 6) {
        this.textForm = { ...Welcome2 };
      }
      this.$nextTick(() => {
        this.initSort();
      });
      this.OnProcessRows(this.textForm, this.textForm);
      this.mLangs = {};
      if (this.textForm.lang_id) {
        if (this.textForm.others) {
          this.textForm.others.forEach((elem) => {
            this.mLangs[elem.lang_id] = {
              type: elem.type,
              url: elem.url,
              text: elem.text,
              buttons: elem.buttons,
              is_markdown: elem.is_markdown,
            };
            this.OnProcessRows(elem, this.mLangs[elem.lang_id]);
          });
        }
      }
      this.mRadio = this.mEnLangId;
      this.OnHandleRadioChange(this.mRadio);
      this.mCanSyncEn = true;
      this.$forceUpdate();
    },
    OnProcessRows(pElem, pSaveElem) {
      if (pElem.buttons) {
        pSaveElem.Rows = [];
        for (let i = 0; i < pElem.buttons.length; i++) {
          pSaveElem.Rows.push({
            id: (i + 1).toString(),
            text: pElem.buttons[i].map((item) => item.text),
            buttons: JSON.parse(JSON.stringify(pElem.buttons[i])),
          });
        }
      }
    },
    // 判断按钮文字是否为空，并飘字提示
    onIsNullEmpty(pbuttons, pLangId) {
      if (!Array.isArray(pbuttons)) return false;
      let bTip = false;
      for (let i = 0; i < pbuttons.length; ++i) {
        let tList = pbuttons[i];
        if (bTip || !Array.isArray(tList)) {
          break;
        } else {
          for (let j = 0; j < tList.length; ++j) {
            let tItem = tList[j];
            if (!tItem.text) {
              bTip = true;
              break;
            }
          }
        }
      }
      if (bTip) {
        let strLangName = this.langmap[pLangId] || "";
        this.$message.error(strLangName + this.$t('EnterButtonTextAgain'));
      }
      return bTip;
    },
    submitTextForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // for (const nLangId in this.mLangs) {
          //   if ((this.onIsNullEmpty(this.mLangs[nLangId].buttons), nLangId))
          //     return;
          // }
          let tSaveData = {};
          let tEnData = this.mLangs[this.mEnLangId];
          tSaveData.lang_id = Number(this.mEnLangId);
          tSaveData.type = tEnData.type;
          tSaveData.url = tEnData.url;
          tSaveData.text = tEnData.text;
          tSaveData.buttons = JSON.parse(
            JSON.stringify(tEnData.Rows.map((item) => item.buttons))
          );
          tSaveData.is_markdown =
            tEnData.is_markdown == undefined ? false : tEnData.is_markdown;
          tSaveData.others = [];
          for (const nLangId in this.mLangs) {
            if (nLangId == this.mEnLangId) {
              continue;
            }
            let tItem = {};
            let tLangData = this.mLangs[nLangId];
            tItem.lang_id = Number(nLangId);
            tItem.type = tLangData.type;
            tItem.url = tLangData.url;
            tItem.text = tLangData.text;
            tItem.buttons = JSON.parse(
              JSON.stringify(tLangData.Rows.map((item) => item.buttons))
            );
            tItem.is_markdown =
              tLangData.is_markdown == undefined
                ? false
                : tLangData.is_markdown;
            tSaveData.others.push(tItem);
          }

          if (this.showEditType == 1) {
            this.editForm.Welcome = JSON.stringify(tSaveData);
          }
          if (this.showEditType == 6) {
            this.editForm.Welcome2 = JSON.stringify(tSaveData);
          }
          this.showEditText = false;
        } else {
          return false;
        }
      });
    },
    // 获取详情
    getDetail() {
      try {
        this.loading = true;
        const data = {
          SellerId: this.dialogData.row.SellerId,
          Id: this.dialogData.row.Id,
          TgRobotType: this.mTgRobotType,
        };
        app.post("/tgRobot/info", data, (res) => {
          if (res.code == 200) {
            this.editForm = { ...res.data.data };
            // if (Number(this.editForm.IsTiyanjin) == 0) {
            //   // 0 和 2，都是关闭，下拉选项只列举数值2，所以这里强制转换为数值2
            //   this.editForm.IsTiyanjin = 2;
            // }
            this.editForm.IsTiyanjin = 1; // 固定有
            if (Number(this.editForm.IsAotoTyj2) == 0) {
              // 0 和 2，都是关闭，下拉选项只列举数值2，所以这里强制转换为数值2
              this.editForm.IsAotoTyj2 = 2;
            }
            if (Number(this.editForm.IsIPRestriction) == 0) {
              // 0 和 2，都是关闭，下拉选项只列举数值2，所以这里强制转换为数值2
              this.editForm.IsIPRestriction = 2;
            }
            if (Number(this.editForm.IsDeviceRestriction) == 0) {
              // 0 和 2，都是关闭，下拉选项只列举数值2，所以这里强制转换为数值2
              this.editForm.IsDeviceRestriction = 2;
            }
            if (Number(this.editForm.IsWalletRestriction) == 0) {
              // 0 和 2，都是关闭，下拉选项只列举数值2，所以这里强制转换为数值2
              this.editForm.IsWalletRestriction = 2;
            }
            this.onParseIPWhitelist();
            this.getGameLink(this.editForm.CSGroup);
            this.getAccount();
            this.loading = false;
            this.editForm.KefuTgUserName = this.OnChangeBtnUrl(
              this.editForm.KefuTgUserName
            );
          }
        });
      } catch (error) {
        this.loading = false;
      }
    },
    onParseIPWhitelist() {
      let tList = this.editForm.IPWhitelist.split(",");
      this.configTableData.length = 0;
      tList.forEach((item, index) => {
        if (item.length > 0) {
          this.configTableData.push({
            WhiteIP: item,
          });
        }
      });
    },
    onStringifyIPWhitelist() {
      if (this.configTableData.length > 0) {
        let tList = [];
        this.configTableData.forEach((item, index) => {
          tList.push(item.WhiteIP);
        });
        return tList.join(",");
      }
      return "";
    },
    OnChangeBtnUrl(pUrl) {
      if (pUrl.startsWith("@")) {
        return pUrl.replace("@", "https://t.me/");
      }
      return pUrl;
    },
    add() {
      const data = {
        SellerId: +this.editForm.SellerId,
        ChannelId: Number(this.editForm.ChannelId),
        TgRobotUserName: this.editForm.TgRobotUserName,
        KefuTgUserName: this.OnChangeBtnUrl(this.editForm.KefuTgUserName),
        TgRobotToken: this.editForm.TgRobotToken,
        GameUrl: this.editForm.GameUrl,
        Welcome: this.editForm.Welcome,
        Welcome2: this.editForm.Welcome2,
        BindMsg: this.editForm.BindMsg,
        GuideMsg: this.editForm.GuideMsg,
        FuLiMsg: this.editForm.FuLiMsg,
        FirstChargeActive: this.editForm.FirstChargeActive,
        IsEnable: Number(this.editForm.IsEnable),
        IsIPRestriction: Number(this.editForm.IsIPRestriction),
        IsDeviceRestriction: Number(this.editForm.IsDeviceRestriction),
        IsWalletRestriction: Number(this.editForm.IsWalletRestriction),
        IsTiyanjin: 1, // 固定有 Number(this.editForm.IsTiyanjin),
        IsAotoTyj2: Number(this.editForm.IsAotoTyj2),
        TgAccountId: this.editForm.TgAccountId,
        GoogleCode: this.editForm.GoogleCode,
        GroupChatId: +this.editForm.GroupChatId,
        TgRobotType: this.mTgRobotType,
        IPWhitelist: this.onStringifyIPWhitelist(),
        H5KefuPopText: this.editForm.H5KefuPopText,
        H5KefuLink: this.editForm.H5KefuLink,
      };
      app.post("/tgRobot/creat", data, (res) => {
        if (res.code == 200) {
          this.$message.success("新增成功");
          this.$emit("success");
          this.dialogData.show = false;
        }
      });
    },
    edit() {
      const data = {
        SellerId: +this.editForm.SellerId,
        ChannelId: Number(this.editForm.ChannelId),
        TgRobotUserName: this.editForm.TgRobotUserName,
        KefuTgUserName: this.OnChangeBtnUrl(this.editForm.KefuTgUserName),
        TgRobotToken: this.editForm.TgRobotToken,
        GameUrl: this.editForm.GameUrl,
        Welcome: this.editForm.Welcome,
        Welcome2: this.editForm.Welcome2,
        BindMsg: this.editForm.BindMsg,
        GuideMsg: this.editForm.GuideMsg,
        FuLiMsg: this.editForm.FuLiMsg,
        FirstChargeActive: this.editForm.FirstChargeActive,
        IsEnable: Number(this.editForm.IsEnable),
        IsIPRestriction: Number(this.editForm.IsIPRestriction),
        IsDeviceRestriction: Number(this.editForm.IsDeviceRestriction),
        IsWalletRestriction: Number(this.editForm.IsWalletRestriction),
        IsTiyanjin: 1, // 固定有 Number(this.editForm.IsTiyanjin),
        IsAotoTyj2: Number(this.editForm.IsAotoTyj2),
        GoogleCode: this.editForm.GoogleCode,
        Id: this.dialogData.row.Id,
        TgAccountId: this.editForm.TgAccountId,
        GroupChatId: +this.editForm.GroupChatId,
        TgRobotType: this.mTgRobotType,
        IPWhitelist: this.onStringifyIPWhitelist(),
        H5KefuPopText: this.editForm.H5KefuPopText,
        H5KefuLink: this.editForm.H5KefuLink,
      };
      app.post("/tgRobot/update", data, (res) => {
        if (res.code == 200) {
          this.$message.success(this.$t('EditSuccess'));
          this.$emit("success");
          this.dialogData.show = false;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editForm.Welcome)
            return this.$message.warning(this.$t('EnterInLibraryWelcomeCopy'));
          if (!this.editForm.Welcome2)
            return this.$message.warning(this.$t('EnterNotInLibraryWelcomeCopy'));
          if (this.editForm.GroupChatId > 0)
            return this.$message.warning(this.$t('ReportGroupChatIdCannotBeZeroAgain'));
          if (this.dialogData.title == this.$t('newAnnouncementAreation')) {
            this.add();
          } else {
            this.edit();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100% !important;
  height: 100px !important;
  line-height: 100px !important;
  text-align: center;
}

::v-deep .avatar {
  width: 100% !important;
  height: 100px !important;
  display: block;
}

::v-deep .el-upload--text {
  width: 100% !important;
  height: 100px !important;
}

.videole {
  width: 100% !important;
  height: 100px !important;
}
.root {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gameItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.lab {
  text-align: center;
}
.red-dot {
  position: absolute;
  top: -1px;
  right: -1px;
}
.red-box {
  border: 2px solid red; /* 红色实线框 */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  padding: 10px 0px;
}
</style>
